import React from 'react';
import {LayoutSidebar} from '../../../Layout';
import {AgencyIABoosterContent} from './AgencyIABoosterContent';

/**
 * Pantalla "AI Booster" sin cliente elegido (`/ia-booster`).
 *
 * Shell mínimo, patrón del repo: `LayoutSidebar` bifurca solo entre el marco clásico y el de la
 * UX 2.1. En el clásico no existe el grupo AI Booster de la barra lateral —o sea, no hay forma de
 * llegar acá— pero la ruta responde igual si alguien la escribe: el contenido resuelve el gate
 * (sin memoria, sin bitácora y sin módulos de IA, redirige al Listado).
 */
export function AgencyIABooster() {
    return (
        <div className="app-content">
            <LayoutSidebar/>
            <AgencyIABoosterContent/>
        </div>
    );
}

export default AgencyIABooster;
